export default __webpack_public_path__ + "static/media/301.63701894.gif";